import React from 'react';
import ReactDOM from 'react-dom'; // Cambia esta línea
import './i18n.js'; // Importa la configuración de i18next
import App from './App';
import { GlobalVariablesProvider } from './context/GlobalVariablesContext';
import { ClickToComponent } from "click-to-react-component";
import { getProjectID, isAppDomain } from './utils/misc';

/**
 * Bootstrap
 */
if (__IS_LARAVEL_BUILD__ !== 'true') {
    import('bootstrap/dist/css/bootstrap.min.css');
}
import './index.css';

// Get the container element
function getAppContainer() {
    return document.getElementById('visor-app');
}
window.getMainAppContainer = getAppContainer;

// Get the viewer container
function getViewerContainer() {
    return document.getElementById('viewer-container');
}
window.getViewerContainer = getViewerContainer;

// Inject X-Project-ID header (and pid query fallback) into same-origin fetch requests
// so backend can apply geographic restrictions based on project.
(() => {
    const originalFetch = window.fetch ? window.fetch.bind(window) : null;
    if (!originalFetch) return;

    window.fetch = async (input, init = {}) => {
        try {
            const projectId = getProjectID();
            if (!projectId) {
                return originalFetch(input, init);
            }

            let url;
            let options;

            if (input instanceof Request) {
                url = input.url;
                // Start from the Request's options, allow overrides via init
                options = {
                    method: input.method,
                    headers: new Headers(input.headers),
                    body: input.body,
                    mode: input.mode,
                    credentials: input.credentials,
                    cache: input.cache,
                    redirect: input.redirect,
                    referrer: input.referrer,
                    referrerPolicy: input.referrerPolicy,
                    integrity: input.integrity,
                    keepalive: input.keepalive,
                    signal: input.signal,
                    ...init,
                };
                options.headers = new Headers(options.headers || {});
            } else {
                url = String(input);
                options = { ...(init || {}) };
                options.headers = new Headers((init && init.headers) || {});
            }

            // Only modify same-origin requests
            if (isAppDomain(url)) {
                // Add header if not already provided by caller
                if (!options.headers.has('X-Project-ID')) {
                    options.headers.set('X-Project-ID', projectId);
                }

                // Fallback: also add pid as query param if neither pid nor project_id present
                try {
                    const urlObj = new URL(url, window.location.origin);
                    const hasPid = urlObj.searchParams.has('pid') || urlObj.searchParams.has('project_id');
                    if (!hasPid) {
                        urlObj.searchParams.set('pid', projectId);
                    }
                    url = urlObj.toString();
                } catch (e) {
                    // no-op if URL parsing fails
                }
            }

            if (input instanceof Request) {
                const req = new Request(url, options);
                return originalFetch(req);
            }

            return originalFetch(url, options);
        } catch (e) {
            return originalFetch(input, init);
        }
    };
})();

ReactDOM.render(
    <React.StrictMode>
        <GlobalVariablesProvider container={getAppContainer()}>
            <App />
            <ClickToComponent />
        </GlobalVariablesProvider>
    </React.StrictMode>,
    getAppContainer()
);